<template>
  <div
    :class="[_.block, full && _.full, padding && _.padding, noTop && _.noTop]"
  >
    <div v-if="title" :class="_.hd">
      <div :class="_.title">
        <div :class="_.text">
          {{ title }}
        </div>
        <div v-if="desc" :class="_.desc">
          {{ desc }}
        </div>
      </div>
      <div v-if="handleMoreClick" :class="_.more" @click="handleMoreClick">
        <div :class="_.text">{{ moreText }}</div>
        <van-icon name="arrow" :class="_.arrow" />
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      // 标题
      title: {
        type: String,
        default: '',
      },
      // 描述
      desc: {
        type: String,
        default: '',
      },
      // 更多文本
      moreText: {
        type: String,
        default: '更多',
      },
      // 点击更多
      handleMoreClick: {
        type: Function,
        default: undefined,
      },
      // 充满的主内容
      full: {
        type: Boolean,
        default: false,
      },
      // 使用 padding 补白
      padding: {
        type: Boolean,
        default: false,
      },
      // 无上补白
      noTop: {
        type: Boolean,
        default: false,
      },
    },
  })
</script>

<style lang="scss" module>
  .block {
    .hd {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title {
        display: flex;
        align-items: center;

        .text {
          font-size: 18px;
          font-weight: bold;
          color: #222222;
        }

        .desc {
          margin-left: 8px;
          font-size: 12px;
          color: #999999;
        }
      }

      .more {
        display: flex;
        align-items: center;

        .text {
          font-size: 12px;
          color: #999999;
        }

        .arrow {
          margin-left: 2px;
          font-size: 12px;
          color: #999999;
        }

        &:active {
          opacity: 0.8;
        }
      }
    }

    $vertical-margin: 16px;
    $hd-bottom-margin: 8px;

    &.full {
      margin: $vertical-margin 0;

      .hd {
        margin: 0 12px $hd-bottom-margin 12px;
      }

      &.padding {
        margin: 0;
        padding: $vertical-margin 0;

        .hd {
          margin: 0;
          padding: 0 12px $hd-bottom-margin 12px;
        }
      }

      &.noTop {
        margin-top: 0;
        padding-top: 0;
      }
    }

    &:not(.full) {
      margin: $vertical-margin 12px;

      .hd {
        margin: 0 0 $hd-bottom-margin 0;
      }

      &.padding {
        margin: 0;
        padding: $vertical-margin 12px;

        .hd {
          margin: 0;
          padding: 0 0 $vertical-margin 0;
        }
      }

      &.noTop {
        margin-top: 0;
        padding-top: 0;
      }
    }
  }
</style>
